window.JustCancel = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            justCancelForm: '#just-cancellation',
            button: {
                cancel: '#just-cancellation-cancel',
                next: '#just-cancellation-continue'
            },
            messages: {
                error: '#just-cancellation-error',
                checkboxError: '#just-cancellation-invalid-error'

            },
            checkBox: {
                confirmCheck: '#just-cancellation-checkbox',
            },
            selectBox: {
                cancellationReason: '#just-cancellation-select-input'
            },
        },
        css: {
            invalidCheckbox: 'vds-checkbox--invalid',
            confirmCheckContainer: '#just-cancellation-check-container'
        },
        urls: {
            updateCancellationReason: '/api/sitecore/PolicyCancellation/SendJustPolicyCancellationDetails',
            managePlanPageUrl: '/my-health-insurance/manage-my-plan',
            successPageUrl: '/my-health-insurance/manage-my-plan/plan-cancellation/just-cancel/request-submitted',
            errorPageUrl: '/error/error-page',
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.messages.checkboxError).hide();
                $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
            },
            bindings: function () {
                $(self.elements.justCancelForm).on('submit', self.func.handleContinue);
                $(self.elements.checkBox.confirmCheck).on('change', self.func.validateCheckbox);
            },
            handleCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.checkboxError).hide();
                    $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
                    return true;
                } else {
                    $(self.elements.messages.checkboxError).show();
                    $(self.css.confirmCheckContainer).addClass(self.css.invalidCheckbox);
                    return false;
                }
            },
            validateCheckbox: function () {
                if ($(self.elements.checkBox.confirmCheck).is(':checked')) {
                    $(self.elements.messages.checkboxError).hide();
                    $(self.css.confirmCheckContainer).removeClass(self.css.invalidCheckbox);
                }
            },
            handleContinue: function (event) {
                event.preventDefault();
                if (self.func.handleCheckbox()) {
                    self.func.submitFormData();
                }
            },
            submitFormData: function () {
                const reason = $(self.elements.selectBox.cancellationReason).val();
                $.ajax({
                    url: self.urls.updateCancellationReason,
                    type: 'PATCH',
                    data: { reason: reason }
                })
                    .done(function (response) {
                        if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                            window.location.href = self.urls.successPageUrl;
                        } else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('just-cancellation' === $('#just-cancellation').data('feature')) {
        window.JustCancel.Init();
    }
});
